// components
import { Modal, ModalContent } from 'shared/components/bulma/modal';
// components

const ModalFeedbacks = ({ modal, handleModal, items, label }) => {

    const handleExit = () => {
        handleModal(false);
    };

    if (items.length === 0) {
        return null;
    }

    return (
        <Modal title={label} isActive={modal} onExit={handleExit} className="is-large">
            <ModalContent>
                <div className="columns is-multiline is-mobile">
                    {items.map((item) => (
                        <div className="column is-3-desktop p-0 is-half-mobile is-one-third-tablet">
                            <div key={item.id}>
                                <img src={item.imageURL} alt={item.documentID} />
                            </div>
                        </div>
                    ))}
                </div>
            </ModalContent>
        </Modal>

    );
}

export { ModalFeedbacks };
